import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Styles as S } from '~/pages/history/multipleChoice/studyGoal/styles'
import { Button } from '~/shared/components/Button'
import { OptionType } from '~/shared/constants/commonConstants'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'
import { shuffleArray } from '~/shared/utils'

const QUESTION = 'What kind of learning do you like the most?'

const OPTIONS = [
  { key: 'interactive', i18nKey: 'first' },
  { key: 'visual', i18nKey: 'second' },
  { key: 'practical', i18nKey: 'third' },
  { key: 'audio', i18nKey: 'fourth' },
  { key: 'text', i18nKey: 'fifth' },
] as const

const LikeMost = ({ nextPagePath, pageId }: TPageProps) => {
  const { t } = useTranslation('history')
  const [answers, setAnswers] = useState<string[]>([])
  const [shuffledOptions] = useState(() => shuffleArray(OPTIONS))

  const handleOptionChange = (optionValue: string, isChecked: boolean) => {
    setAnswers((prev) =>
      isChecked
        ? [...prev, optionValue]
        : prev.filter((item) => item !== optionValue),
    )
  }

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question: QUESTION,
  })

  return (
    <S.Root>
      <S.StyledContainer>
        <S.ScrollContent>
          <S.Content>
            <S.Title>
              <Trans ns="history" i18nKey="onboarding.historyLikeMost.title" />
            </S.Title>
          </S.Content>

          {shuffledOptions.map(({ key, i18nKey }) => {
            const optionText = t(
              `onboarding.historyLikeMost.options.${i18nKey}`,
            )
            const spaceIndex = optionText.indexOf(' ')
            const emoji =
              spaceIndex !== -1 ? optionText.slice(0, spaceIndex) : optionText
            const text =
              spaceIndex !== -1 ? optionText.slice(spaceIndex + 1) : ''

            return (
              <S.StyledOption
                key={key}
                type={OptionType.CHECKBOX}
                value={key}
                name="likeMost"
                onChange={handleOptionChange}
                checked={answers.includes(key)}
              >
                <S.Value>
                  <S.OptionIcon>{emoji}</S.OptionIcon>
                  <S.ValueText>{text}</S.ValueText>
                </S.Value>
              </S.StyledOption>
            )
          })}
        </S.ScrollContent>

        <S.ButtonContainer>
          <Button
            type="button"
            onClick={() => handleContinue(answers)}
            disabled={!answers.length}
          >
            <Trans i18nKey="actions.continue" />
          </Button>
        </S.ButtonContainer>
      </S.StyledContainer>
    </S.Root>
  )
}

export default LikeMost
